import React, { useEffect, useRef, useState } from 'react';

// The listing design's gap between a select and its open menu.
const MENU_GAP = 5;

function Caret({ open }) {
    return (
        <svg className={'ls-select__caret' + (open ? ' is-open' : '')} width="11" height="11" viewBox="0 0 11 11"
            fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
            <path d="M3 4.3 L5.5 6.8 L8 4.3" />
        </svg>
    );
}

export function Menu({ label, value, options, onPick }) {
    const [place, setPlace] = useState(null);
    const select = useRef(null);
    const menu = useRef(null);
    const current = options.filter((option) => option[0] === value)[0];
    const open = place !== null;

    // Placed against the window: inside the dialog's scrolling body the open
    // menu made the body scroll, and its options sat under the footer.
    const toggle = () => {
        if (open) {
            setPlace(null);
            return;
        }

        const box = select.current.getBoundingClientRect();
        const top = box.bottom + MENU_GAP;

        // On a short window the menu keeps to the room below and scrolls.
        setPlace({ top, left: box.left, width: box.width, maxHeight: window.innerHeight - top - MENU_GAP });
    };

    // A scroll or a resize would leave the menu behind, away from its select.
    useEffect(() => {
        if (!open) return undefined;

        const close = (event) => {
            if (event.type === 'scroll' && menu.current && menu.current.contains(event.target)) return;
            setPlace(null);
        };

        window.addEventListener('resize', close);
        window.addEventListener('scroll', close, true);
        return () => {
            window.removeEventListener('resize', close);
            window.removeEventListener('scroll', close, true);
        };
    }, [open]);

    return (
        <div className="ls-field ls-field--menu">
            {label && <span className="ls-field__label">{label}</span>}
            <button ref={select} type="button" className={'ls-select' + (open ? ' is-open' : '')} onClick={toggle}>
                <span className="ls-select__value">{current ? current[1] : value}</span>
                <Caret open={open} />
            </button>
            {open && (
                <div ref={menu} className="ls-menu or-menu" style={place}>
                    {options.map(([key, name]) => (
                        <button
                            key={key}
                            type="button"
                            className={'ls-menu__item' + (key === value ? ' is-on' : '')}
                            onClick={() => {
                                onPick(key);
                                setPlace(null);
                            }}
                        >
                            <span className="ls-menu__name">{name}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
